import { relayStylePagination } from '@apollo/client/utilities';
import { getHomeTitle, getOverallStatus } from 'utils/productStatus.utils';

const queryPolicies = {
  Query: {
    fields: {
      documents: relayStylePagination(['first']),
      sharedDocuments: relayStylePagination(['first']),
      partners: relayStylePagination(['first']),
      videos: relayStylePagination(['filters', 'first']),
      getImages: relayStylePagination(['first']),
      payments: relayStylePagination(['first']),
      datasets: relayStylePagination(['filters', 'first']),
      components: relayStylePagination(['filters', 'first']),
      sites: relayStylePagination(['filters', 'siteViewOption', 'orderBy', 'first']),
      activities: relayStylePagination(['filters', 'first']),
      plots: relayStylePagination(['filters', 'orderBy', 'first']),
      products: relayStylePagination(['filters', 'orderBy', 'first']),
      chains: relayStylePagination(['first']),
      impactClaims: relayStylePagination(['filters', 'first']),
      product: (existingData, { args, toReference }) => {
        return existingData || toReference({ __typename: 'Product', id: args.productId });
      },
      overallProductStatus: (_, { readField }) => {
        const originalProducts = readField({
          fieldName: 'products',
          args: {},
        });

        const { edges = [] } = originalProducts || {};

        const products = edges.map(({ node }) => {
          return {
            status: readField('status', node),
            contentStatus: readField('contentStatus', node),
          };
        });
        const status = getOverallStatus(products);

        return {
          status,
          homeTitle: status ? getHomeTitle(status) : '',
        };
      },
    },
  },
};

export default queryPolicies;
